import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { ADD_INVESTOR_IMAGE } from "./apiRoutes";

const mutateAddInvestorInfoImage = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${ADD_INVESTOR_IMAGE}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const useAddInvestorInfoImageMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddInvestorInfoImage,
    ...queryParams,
  });

export default useAddInvestorInfoImageMutation;
